import React from 'react';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import landing_background1 from '../../img/other/landing_background1.jpg'
import landing_background2 from '../../img/other/landing_background2.jpg'
import { Typography, Paper } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEuroSign, faUserMd, faBus, faUser, faHeart, faShieldAlt } from '@fortawesome/free-solid-svg-icons'
import { isMobile } from 'react-device-detect';
import AppBarPortal from '../shared/components/AppBarPortal';
import AppBarLandingMobile from '../shared/components/AppBarLandingMobile';
import DrawerLandingMobile from '../shared/components/DrawerLandingMobile';

const styles = theme => ({
  container: {
    display: 'flex', 
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    }
  },
  section1: {
    background: 'url('+landing_background2+') no-repeat center center',
    backgroundPositionY: 'bottom',
    borderBottom: '3px solid #fff',
    height: 'calc(50% - 3px)',
    minHeight: 450,
    [theme.breakpoints.down('md')]: {
      height: 'auto',
      minHeight: 'auto'
    }
  },
  section2: {
    background: 'url('+landing_background1+') no-repeat center center',
    backgroundPositionY: 'center',
    height: '50%',
    minHeight: 450,
    [theme.breakpoints.down('md')]: {
      height: 'auto',
      minHeight: 'auto'
    }
  },
  paper: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    position: 'absolute',
    bottom: 0,
    borderRadius: 0,
    minHeight: '90%',
    [theme.breakpoints.down('md')]: {
      position: 'initial',
      paddingTop: theme.spacing.unit * 5,
      paddingBottom: theme.spacing.unit * 3,
    }
  },
  iconContainer: {
    border: '1px solid #42b8d4',
    borderRadius: '50%',
    padding: 0,
    textAlign: 'center',
    width: 64,
    height: 64,
    display: 'table-cell',
    verticalAlign: 'middle',
    [theme.breakpoints.between("sm", "md")]: {
      width: 48,
      height: 48,
    }
  },
  buttonIndigo: theme.custom.button.indigo,
  container1280: {
    height: '100%', 
    padding: '0 25px 0 25px', 
    maxWidth: 1280, 
    margin: '0 auto',
    [theme.breakpoints.between(1150,'lg')]: {
      maxWidth: 1150,
    },
  },
  containerMobile: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
    }
  },
  "@global": {
    html: {
      [theme.breakpoints.between("sm", "md")]: {
        fontSize: 11
      }
    }
  }
})


class Homepage extends React.Component {
  componentDidMount() {
    document.body.classList.add("login");
  }

  componentWillUnmount() {
    document.body.classList.remove("login");
  }
  render() {

    const { classes } = this.props;

    return (
      <React.Fragment>
        {!isMobile && <AppBarPortal />}

      <div className={classes.container}>
        <Grid container spacing={0}>
          <Grid item xs={12} className={classes.section1}>

            <Grid container className={classes.container1280}>
              <Grid item xs={12} md={8} style={{alignSelf: 'center'}}>
                <Typography paragraph variant="display2" style={{color: '#000'}}>
                ¿Te gustan los productos cosméticos y quieres ganar dinero extra a fin de mes?
                </Typography>
                <Typography paragraph variant="subheading">
                  Regístrate ahora como
                </Typography>
                <Button variant="contained" className={classes.buttonIndigo} component={Link} to='/register?type=v'>Voluntario</Button>
              </Grid>
              <Grid item xs={12} md={4}>
                <div style={{position: 'relative', height: '100%'}}>
                <Paper className={classes.paper}>
                
                  <Grid container spacing={0}>
                    <Grid item xs={3}>
                      <div className={classes.iconContainer}>
                        <FontAwesomeIcon icon={faEuroSign} mask={['far', 'circle']} size="2x" color="#42b8d4" />
                      </div>
                    </Grid>
                    <Grid item xs={9}>
                      <Typography variant="headline" component="div">Gratificación</Typography>
                      <Typography paragraph variant="subheading">Una forma agradable y fácil de ganar un dinero extra a fin de mes.</Typography>
                    </Grid>
                  </Grid>

                  <Grid container spacing={0}>
                    <Grid item xs={3}>
                      <div className={classes.iconContainer}>
                        <FontAwesomeIcon icon={faUserMd} mask={['far', 'circle']} size="2x" color="#42b8d4" />
                      </div>
                    </Grid>
                    <Grid item xs={9}>
                      <Typography variant="headline" component="div">Equipo profesional</Typography>
                      <Typography paragraph variant="subheading">Estudios realizados con total seguridad gracias a nuestros equipos de experimentados científicos y a nuestros médicos (dermatólogo, oftalmólogo...).</Typography>
                    </Grid>
                  </Grid>

                  <Grid container spacing={0}>
                    <Grid item xs={3}>
                      <div className={classes.iconContainer}>
                        <FontAwesomeIcon icon={faBus} mask={['far', 'circle']} size="2x" color="#42b8d4" />
                      </div>
                    </Grid>
                    <Grid item xs={9}>
                      <Typography variant="headline" component="div">Ven a conocernos</Typography>
                      <Typography paragraph variant="subheading">¿Vives en Barcelona o en los alrededores y quieres probar productos cosméticos de calidad ? Apúntate y ven a la revisión médica que te permitirá realizar estos estudios.</Typography>
                    </Grid>
                  </Grid>

                </Paper>
                </div>
              </Grid>
            </Grid>

          </Grid>
          <Grid item xs={12} className={classes.section2}>

            <Grid container className={classes.container1280}>
              <Grid item xs={12} md={8} style={{alignSelf: 'center'}}>
                <Typography paragraph variant="display2" style={{color: '#000'}}>
                O si encantan los productos cosméticos y quieres ser el primero en probar productos de calidad…
                </Typography>
                <Typography paragraph variant="subheading">
                  Regístrate ahora como
                </Typography>
                <Button variant="contained" className={classes.buttonIndigo} component={Link} to='/register?type=c'>Consumidor</Button>
              </Grid>
              <Grid item xs={12} md={4}>
                <div style={{position: 'relative', height: '100%'}}>
                  <Paper className={classes.paper}>
                  
                    <Grid container spacing={0}>
                      <Grid item xs={3}>
                        <div className={classes.iconContainer}>
                          <FontAwesomeIcon icon={faUser} mask={['far', 'circle']} size="2x" color="#42b8d4" />
                        </div>
                      </Grid>
                      <Grid item xs={9}>
                        <Typography variant="headline" component="div">Panel consumidores</Typography>
                        <Typography paragraph variant="subheading">
                        Tienes entre 18 y 70 años, tienes tiempo libre y vives en España.
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={0}>
                      <Grid item xs={3}>
                        <div className={classes.iconContainer}>
                          <FontAwesomeIcon icon={faHeart} mask={['far', 'circle']} size="2x" color="#42b8d4" />
                        </div>
                      </Grid>
                      <Grid item xs={9}>
                        <Typography variant="headline" component="div">Comparte tu opinión</Typography>
                        <Typography paragraph variant="subheading">
                          Tu opinión es importante. Prueba productos cosméticos de calidad sin desplazarte y dinos qué piensas..
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={0}>
                      <Grid item xs={3}>
                        <div className={classes.iconContainer}>
                          <FontAwesomeIcon icon={faShieldAlt} mask={['far', 'circle']} size="2x" color="#42b8d4" />
                        </div>
                      </Grid>
                      <Grid item xs={9}>
                        <Typography variant="headline" component="div">Productos de calidad</Typography>
                        <Typography paragraph variant="subheading">
                          Los productos probados han sido previamente evaluados y aprobados por nuestros expertos, así 
                          que pueden utilizarse con total seguridad.
                        </Typography>

                      </Grid>
                    </Grid>

                  </Paper>
                </div>
              </Grid>
            </Grid>

          </Grid>
        </Grid>
      </div>
      
      {isMobile && <AppBarLandingMobile />}
      {isMobile && <DrawerLandingMobile />}
      <div className={classes.containerMobile}>
        
        <Grid container>
          <Grid item xs={12}>
            <div style={{ padding: 20, textAlign: 'center', background: 'url('+landing_background2+') no-repeat' }}>
              <Typography paragraph variant="display1" style={{color: '#000'}}>
                ¿Te gustan los productos cosméticos y quieres ganar dinero extra a fin de mes?
              </Typography>
              <Typography paragraph variant="subheading">
                Regístrate ahora como
              </Typography>
              <Button variant="contained" className={classes.buttonIndigo} component={Link} to='/register?type=v'>Voluntario</Button>
            </div>
          </Grid>
          <Grid item xs={12}>
            <Paper className={classes.paper}>
                
              <Grid container spacing={0}>
                <Grid item xs={3}>
                  <div className={classes.iconContainer}>
                    <FontAwesomeIcon icon={faEuroSign} mask={['far', 'circle']} size="2x" color="#42b8d4" />
                  </div>
                </Grid>
                <Grid item xs={9}>
                  <Typography variant="headline" component="div">Gratificación</Typography>
                  <Typography paragraph variant="subheading">Una forma agradable y fácil de ganar un dinero extra a fin de mes.</Typography>
                </Grid>
              </Grid>

              <Grid container spacing={0}>
                <Grid item xs={3}>
                  <div className={classes.iconContainer}>
                    <FontAwesomeIcon icon={faUserMd} mask={['far', 'circle']} size="2x" color="#42b8d4" />
                  </div>
                </Grid>
                <Grid item xs={9}>
                  <Typography variant="headline" component="div">Equipo profesional</Typography>
                  <Typography paragraph variant="subheading">Estudios realizados con total seguridad gracias a nuestros equipos de experimentados científicos y a nuestros médicos (dermatólogo, oftalmólogo...).</Typography>
                </Grid>
              </Grid>

              <Grid container spacing={0}>
                <Grid item xs={3}>
                  <div className={classes.iconContainer}>
                    <FontAwesomeIcon icon={faBus} mask={['far', 'circle']} size="2x" color="#42b8d4" />
                  </div>
                </Grid>
                <Grid item xs={9}>
                  <Typography variant="headline" component="div">Ven a conocernos</Typography>
                  <Typography paragraph variant="subheading">¿Vives en Barcelona o en los alrededores y quieres probar productos cosméticos de calidad ? Apúntate y ven a la revisión médica que te permitirá realizar estos estudios.</Typography>
                </Grid>
              </Grid>

            </Paper>
          </Grid>
          <Grid item xs={12}>
            <div style={{ padding: 20, textAlign: 'center', background: 'url('+landing_background1+') no-repeat top' }}>
              <Typography paragraph variant="display1" style={{color: '#000'}}>
                O si encantan los productos cosméticos y quieres ser el primero en probar productos de calidad…
              </Typography>
              <Typography paragraph variant="subheading">
                Regístrate ahora como
              </Typography>
              <Button variant="contained" className={classes.buttonIndigo} component={Link} to='/register?type=c'>Consumidor</Button>
            </div>
          </Grid>
          <Grid item xs={12}>
            <Paper className={classes.paper}>
                  
              <Grid container spacing={0}>
                <Grid item xs={3}>
                  <div className={classes.iconContainer}>
                    <FontAwesomeIcon icon={faUser} mask={['far', 'circle']} size="2x" color="#42b8d4" />
                  </div>
                </Grid>
                <Grid item xs={9}>
                  <Typography variant="headline" component="div">Panel consumidores</Typography>
                  <Typography paragraph variant="subheading">
                  Tienes entre 18 y 70 años, tienes tiempo libre y vives en España.
                  </Typography>
                </Grid>
              </Grid>

              <Grid container spacing={0}>
                <Grid item xs={3}>
                  <div className={classes.iconContainer}>
                    <FontAwesomeIcon icon={faHeart} mask={['far', 'circle']} size="2x" color="#42b8d4" />
                  </div>
                </Grid>
                <Grid item xs={9}>
                  <Typography variant="headline" component="div">Comparte tu opinión</Typography>
                  <Typography paragraph variant="subheading">
                    Tu opinión es importante. Prueba productos cosméticos de calidad sin desplazarte y dinos qué piensas..
                  </Typography>
                </Grid>
              </Grid>

              <Grid container spacing={0}>
                <Grid item xs={3}>
                  <div className={classes.iconContainer}>
                    <FontAwesomeIcon icon={faShieldAlt} mask={['far', 'circle']} size="2x" color="#42b8d4" />
                  </div>
                </Grid>
                <Grid item xs={9}>
                  <Typography variant="headline" component="div">Productos de calidad</Typography>
                  <Typography paragraph variant="subheading">
                    Los productos probados han sido previamente evaluados y aprobados por nuestros expertos, así 
                    que pueden utilizarse con total seguridad.
                  </Typography>

                </Grid>
              </Grid>

            </Paper>
          </Grid>
        </Grid>
      </div>
      </React.Fragment>
    )
  }
}

export default withStyles(styles, {withTheme: true})(Homepage);


// WEBPACK FOOTER //
// ./src/modules/homepage/Homepage.js